<template>
  <div>
    <table v-once v-bind:id=tableId class="dataTable table table-striped table-bordered" width="100%" cellspacing="0">
      <thead>
      <tr>
        <th>Rechtegruppe</th>
        <th>Rechte</th>
      </tr>
      </thead>
    </table>

    <div>
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
  /* global $ */
  import ModuleService from '../services/ModuleService'

  export default {
    name: 'UserPermissionTable',
    props: ['id', 'payload'],
    data () {
      return {
        // eslint-disable-next-line no-undef
        tableId: (this.$props.id !== undefined) ? 'dTable_' + this.$func.uuid() + '_' + this.$props.id : 'dTable_' + this.$func.uuid()
      }
    },
    methods: {},
    computed: {},
    async mounted () {
      var rechtegruppen = await ModuleService.getPermissiongroupes()
      rechtegruppen = rechtegruppen.data

      // eslint-disable-next-line no-unused-vars
      var router = this.$router
      var tableId = this.tableId
      var path = '/userpermission'
      var self = this

      $(document).ready(function () {
        // eslint-disable-next-line no-undef
        var editor = new $.fn.dataTable.Editor({
          ajax: {
            create: self.$func.addAuth({
              type: 'POST',
              url: path + '/'
            }),
            edit: self.$func.addAuth({
              type: 'PUT',
              url: path + '/_id_/'
            }),
            remove: self.$func.addAuth({
              type: 'DELETE',
              url: path + '/_id_/',
              deleteBody: false
            })
          },
          idSrc: 'id',
          table: '#' + tableId,
          fields: [
            {
              name: 'oUser',
              type: 'hidden'
            },
            {
              label: 'Rechtegruppe:',
              name: 'oPermissionGroupe',
              type: 'selectize',
              closeAfterSelect: true,
              opts: {
                maxItems: 1,
                valueField: 'id',
                searchField: ['sBezeichnung'],
                placeholder: 'Rechtegruppe wählen ...',
                preload: true,
                options: [],
                sortField: [{
                  field: 'sBezeichnung',
                  direction: 'asc'
                }, {
                  field: '$score'
                }],
                create: false,
                render: {
                  option: function (data, escape) {
                    return '<div>' + escape(data.sBezeichnung) + '</div>'
                  },
                  item: function (item, escape) {
                    return '<div>' + escape(item.sBezeichnung) + '</div>'
                  }
                },
                load: function (query, callback) {
                  callback(rechtegruppen)
                }
              }
            }
          ]
        })

        $('#' + tableId).DataTable({
          ajax: self.$func.addAuth({
            url: path + '/' + self.$props.id + '/',
            type: 'GET'
          }),
          scrollX: true,
          scrollY: '300px',
          scrollCollapse: true,
          columns: [

            {
              class: 'center',
              data: 'oPermissionGroupe.sBezeichnung'
            },
            {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                return data.oPermissionGroupe.oPermission_arr.map(x => {
                  return (x.sBezeichnung)
                }).join(',<br>')
              }
            }
          ],
          buttons: [
            {
              extend: 'create',
              editor: editor
            },
            {
              extend: 'remove',
              editor: editor
            }
          ]
        })

        editor
          .on('preOpen', function () {
            editor.set('oUser', self.$props.id)
          })

        $('#' + tableId + ' tbody').on('dblclick', 'tr', function () {
          editor
            .edit(this)
            .title($.fn.dataTable.Editor.defaults.i18n.edit.title)
            .buttons({
              label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            })
        })
      })
    }
  }
</script>
<style>

</style>
